module.exports = ".error-code{font-family:Verdana, sans-serif}\n"